export enum Warnings {
  UNSUPPORTED_PLAN = 'UNSUPPORTED_PLAN',
  INVALID_QUERY_PARAM = 'INVALID_QUERY_PARAM',
  COMPANY_AUTOCOMPLETE_NO_ADDRESS = 'COMPANY_AUTOCOMPLETE_NO_ADDRESS',
  COMPANY_AUTOCOMPLETE_NO_COMPANY = 'COMPANY_AUTOCOMPLETE_NO_COMPANY',
  COMPANY_AUTOCOMPLETE_NO_OWNERS = 'COMPANY_AUTOCOMPLETE_NO_OWNERS',
}
